import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b3f259fe")

_pushScopeId("data-v-b3f259fe")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Get in touch with us")
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("I have general feedback and suggestions for your app")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("I have a subscription question or issue")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("I have a technical issue or feedback")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Send us a message")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Send Message")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_navbar = _resolveComponent("navbar")
  const _component_ion_back_button = _resolveComponent("ion-back-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_radio = _resolveComponent("ion-radio")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_textarea = _resolveComponent("ion-textarea")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_bottombar = _resolveComponent("bottombar")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          (_ctx.isWeb)
            ? (_openBlock(), _createBlock(_component_navbar, { key: 0 }))
            : _createCommentVNode("", true),
          (!_ctx.isWeb)
            ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 1 }, {
                default: _withId(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_back_button, {
                        color: "medium",
                        "default-href": "/",
                        icon: "chevron-back",
                        text: ""
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, { color: "medium" }, {
                    default: _withId(() => [
                      _createTextVNode("Contact " + _toDisplayString(_ctx.client.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, null, {
              default: _withId(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, { class: "text-center" }, {
                      default: _withId(() => [
                        (!_ctx.client.dark_logo || !_ctx.client.light_logo)
                          ? (_openBlock(), _createBlock(_component_ion_img, {
                              key: 0,
                              class: "about-logo",
                              src: _ctx.client.logo
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        (_ctx.client.dark_logo && _ctx.client.light_logo && _ctx.client.mode === 'dark')
                          ? (_openBlock(), _createBlock(_component_ion_img, {
                              key: 1,
                              class: "about-logo",
                              src: 
									_ctx.client.dark_logo
								
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        (_ctx.client.dark_logo && _ctx.client.light_logo && _ctx.client.mode !== 'dark')
                          ? (_openBlock(), _createBlock(_component_ion_img, {
                              key: 2,
                              class: "about-logo",
                              src: 
									_ctx.client.light_logo
								
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, { class: "text-center" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_title, null, {
                          default: _withId(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        }),
                        _hoisted_3,
                        _createVNode(_component_ion_list, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_ion_radio_group, {
                                  class: "text-sm",
                                  value: "general"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_item, null, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_text, null, {
                                          default: _withId(() => [
                                            _hoisted_4
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_radio, {
                                          slot: "start",
                                          value: "general"
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_item, null, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_text, null, {
                                          default: _withId(() => [
                                            _hoisted_5
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_radio, {
                                          slot: "start",
                                          value: "subscription"
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_item, null, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_text, null, {
                                          default: _withId(() => [
                                            _hoisted_6
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_radio, {
                                          slot: "start",
                                          value: "technical"
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_ion_label, { position: "stacked" }, {
                                  default: _withId(() => [
                                    _hoisted_7
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_textarea, {
                                  "clear-on-edit": "true",
                                  modelValue: _ctx.userMsg,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.userMsg = $event)),
                                  value: _ctx.userMsg,
                                  onIonInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.userMsg = $event.target.value))
                                }, null, 8, ["modelValue", "value"]),
                                _hoisted_8
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_ion_button, {
                                  color: "primary",
                                  size: "block",
                                  onClick: _ctx.sendEmail
                                }, {
                                  default: _withId(() => [
                                    _hoisted_9
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_bottombar)
    ]),
    _: 1
  }))
})